import { useState } from 'react';
import { Navigation, Pagination, Swiper as SwiperClass } from 'swiper';
import { Swiper } from 'swiper/react';
import { ReactComponent as LeftArrow } from '../../assets/left_arrow.svg';
import classNames from 'classnames';
import styles from './index.module.css';

interface Props extends React.PropsWithChildren {
  totalSize: number;
  formatLabel?: (currentIndex: number, totalSize: number) => string;
  className?: string;
}

export const SwiperWithArrows: React.FC<Props> = ({
  totalSize,
  formatLabel,
  className,
  children,
}) => {
  const [selectedItem, setSelectedItem] = useState(0);
  const [swiperRef, setSwiper] = useState<SwiperClass>();
  return (
    <div className={className}>
      <div className={styles.CardNavBox}>
        {formatLabel && <div>{formatLabel(selectedItem, totalSize)}</div>}
        <div className={styles.ArrowBox}>
          <LeftArrow
            viewBox="0 0 12 12"
            className={classNames(styles.ArrowIcon, {
              [styles.DisabledIcon]: selectedItem === 0,
            })}
            onClick={() => swiperRef?.slidePrev()}
          />
          <LeftArrow
            viewBox="0 0 12 12"
            className={classNames(styles.ArrowIcon, styles.RightArrow, {
              [styles.DisabledIcon]: selectedItem === totalSize - 1,
            })}
            onClick={() => swiperRef?.slideNext()}
          />
        </div>
      </div>
      <Swiper
        onSwiper={(swiper) => setSwiper(swiper)}
        onSlideChange={(swiper) => {
          setSelectedItem(swiper.realIndex);
        }}
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        pagination={{
          clickable: true,
          bulletClass: styles.Indicator,
          bulletActiveClass: styles.IndicatorSelected,
        }}
      >
        {children}
      </Swiper>
    </div>
  );
};
